export default [
    {
        path: '/test',
        component: () => import('@/pages/test/index.vue'),
        name: 'test',
        meta: {
            title: '测试',
        },
    },
    {
        path: '/test/bridge',
        component: () => import('@/pages/test/bridge.vue'),
        name: 'bridge',
        meta: {
            title: '工具库方法',
        },
    },
];
